<template>
	<div class="py-2 b-t">
		<div
			class="d-flex flex-row align-items-center"
			v-tippy="{ placement: 'bottom-start', theme: 'popover' }"
			:title="assessment.description"
		>
			<div class="flex collapsed">
				<div class="d-flex flex-row">
					<h6 class="flex mb-1 mr-1 collapsed">
						{{ assessment.name }}
						<span v-if="assessment.ref_id">
							•
							<span class="text-muted text-sm">{{ assessment.ref_id }}</span>
						</span>
					</h6>

					<span
						v-if="showRel"
						style="white-space: nowrap;"
						v-tippy="{ placement: 'top' }"
						title="Second scores remaining"
					>
						<i class="fas fa-check-double mr-1 text-muted"></i>
						{{ rel }}
					</span>
					<span v-if="showRel && showRes" class="mx-1">|</span>
					<span
						v-if="showRes"
						style="white-space: nowrap;"
						v-tippy="{ placement: 'top' }"
						title="Resolution scores remaining"
					>
						<i class="fas fa-shield-check mr-1 text-muted"></i>
						{{ res }}
					</span>
				</div>
				<span v-for="grade in assessment.grades" :key="grade.id" class="badge theme-accent mr-1">{{
					grade.name
				}}</span>
				<span v-for="(standard, i) in assessment.standards" :key="i" class="badge theme-accent mr-1">{{
					standard
				}}</span>
				<span v-html=(assessment.description) class="text-muted"></span>
			</div>
			<div class="py-0 ml-2">
				<slot name="actions"></slot>
			</div>
		</div>
	</div>
</template>

<style scoped>
.collapsed {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
</style>

<script>
import fs from "@/services/FormatService";

export default {
	name: "AssessmentRow",
	props: ["assessment", "rel", "res"],

	data() {
		return {
			fs: fs
		};
	},
	created() {},
	watch: {},

	computed: {
		showRel() {
			return !(this.rel == false || isNaN(this.rel));
		},
		showRes() {
			return !(this.res == false || isNaN(this.res));
		}
	},

	computer: {},
	methods: {}
};
</script>



// WEBPACK FOOTER //
// src/components/AssessmentRow.vue